import '@take-2/fd-modules/news/article/app';
